import { Path } from '@/main/router/routerPath';

import { NdSklad } from './ndSklad';
import { NdSkladPreceneni } from './ndSkladPreceneni';
import { NdObjednavkaZakazka } from './ndObjednavka/ndObjednavkaZakazka';
import { NdPrijemka } from './ndPrijemka';
import { NdPohyb } from './ndPohyb';
import { NdObjednavka } from './ndObjednavka';
import { PROrders } from './PROrders';
import { PRInvoice } from './PRInvoice';
import { NdCenik } from './ndCenik';
import { PneuSklad } from './pneuSklad';
import { Inventura } from './inventura';
import { InventuraPolozky } from './inventuraPolozky';
import { Edl } from './edl';
import { CustomerPendingEnquiries } from './CustomerPendingEnquiries';
import { PartsInventoryAdjustment } from './partsInventoryAdjustments';
import { BulkInventoryAdjustments } from './BulkInventoryAdjustments';
import { PRReturn } from './PRReturn';
import { Dealer } from './dealer';
import { BulkInventoryApproval } from './BulkInventoryApproval';


export const router = new Path('sklad').addChildren([
	NdSklad.router,
	NdCenik.router,
	NdPrijemka.router,
	NdPohyb.router,
	NdSkladPreceneni.router,
	NdObjednavka.router,
	PROrders.router,
	PRInvoice.router,
	NdObjednavkaZakazka.router,
	PneuSklad.router,
	Inventura.router,
	InventuraPolozky.router,
	Edl.router,
	CustomerPendingEnquiries.router,
	PartsInventoryAdjustment.router,
	BulkInventoryAdjustments.router,
	PRReturn.router,
	Dealer.router,
	BulkInventoryApproval.router,
]);
